"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFoundRedirect = function NotFoundRedirect() {
  return _react.default.createElement(_reactHelmet.default, {
    meta: [{
      'http-equiv': 'refresh',
      content: '0;URL="/404"'
    }]
  });
};

var _default = NotFoundRedirect;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/shared/NotFoundRedirect.js
// module id = 286
// module chunks = 0